const QTY_SCALE = 1e6;

export const roundQty = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round((n + Number.EPSILON) * QTY_SCALE) / QTY_SCALE;
};

export const formatQty = (value) => {
  const n = roundQty(value);
  if (n == null) return '';
  return String(n);
};

export const sanitizeAddExpression = (raw) =>
  String(raw ?? '')
    .replace(/,/g, '.')
    .replace(/[×xXхХ]/g, '*')
    .replace(/[÷:]/g, '/')
    .replace(/[−–—]/g, '-')
    .replace(/[^\d.+\-*/]/g, '');

const parseNumberAt = (expr, from) => {
  let j = from;
  let dots = 0;
  let digits = 0;
  while (j < expr.length && /[\d.]/.test(expr[j])) {
    if (expr[j] === '.') {
      dots += 1;
      if (dots > 1) return null;
    } else {
      digits += 1;
    }
    j += 1;
  }
  if (digits === 0 || expr[j - 1] === '.') return null;
  const n = Number(expr.slice(from, j));
  if (!Number.isFinite(n)) return null;
  return { n, j };
};

export const evaluateAddExpression = (raw) => {
  const expr = sanitizeAddExpression(raw);
  if (!expr) return { ok: false };

  const tokens = [];
  let i = 0;
  while (i < expr.length) {
    const ch = expr[i];
    const prev = tokens[tokens.length - 1];
    const unary = (ch === '-' || ch === '+') && (prev == null || typeof prev === 'string');
    if (unary) {
      if (ch === '+') {
        i += 1;
        continue;
      }
      const parsed = parseNumberAt(expr, i + 1);
      if (!parsed) return { ok: false };
      tokens.push(-parsed.n);
      i = parsed.j;
      continue;
    }
    if ('+-*/'.includes(ch)) {
      if (typeof prev !== 'number') return { ok: false };
      tokens.push(ch);
      i += 1;
      continue;
    }
    if (/[\d.]/.test(ch)) {
      if (typeof prev === 'number') return { ok: false };
      const parsed = parseNumberAt(expr, i);
      if (!parsed) return { ok: false };
      tokens.push(parsed.n);
      i = parsed.j;
      continue;
    }
    return { ok: false };
  }

  if (!tokens.length || typeof tokens[tokens.length - 1] !== 'number') return { ok: false };

  const collapsed = [];
  for (let t = 0; t < tokens.length; t += 1) {
    const token = tokens[t];
    if (token === '*' || token === '/') {
      const left = collapsed.pop();
      const right = tokens[t + 1];
      t += 1;
      if (typeof left !== 'number' || typeof right !== 'number') return { ok: false };
      if (token === '/' && right === 0) return { ok: false };
      const value = token === '*' ? left * right : left / right;
      if (!Number.isFinite(value)) return { ok: false };
      collapsed.push(value);
    } else {
      collapsed.push(token);
    }
  }

  let acc = collapsed[0];
  if (typeof acc !== 'number') return { ok: false };
  for (let t = 1; t < collapsed.length; t += 2) {
    const op = collapsed[t];
    const right = collapsed[t + 1];
    if ((op !== '+' && op !== '-') || typeof right !== 'number') return { ok: false };
    acc = op === '+' ? acc + right : acc - right;
  }

  const value = roundQty(acc);
  if (value == null) return { ok: false };
  return { ok: true, value };
};
